import { render, staticRenderFns } from "./LoanSummary.vue?vue&type=template&id=60a98762&scoped=true&"
import script from "./LoanSummary.vue?vue&type=script&lang=js&"
export * from "./LoanSummary.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=60a98762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a98762",
  null
  
)

export default component.exports